
import React, { ButtonHTMLAttributes } from 'react';
import { FiEdit, FiFilter, FiPlus, FiTrash } from 'react-icons/fi';
import { Container } from './styles';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    iconType: 'Filter' |  'Remove' | 'Create' | 'Update'
}






const Button: React.FC<ButtonProps> = ({ iconType, ...rest }) => (
    <Container type="button"  {...rest}>

        {   iconType==='Create'   && <FiPlus size={20} color='white' />   }
        {   iconType==='Update'   && <FiEdit size={20} color='white' />   }
        {   iconType==='Filter'   && <FiFilter size={20} color='white' />   }
        {   iconType==='Remove'   && <FiTrash size={20} color='white' />   }

        
    </Container>
);

export default Button;
